var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.visible)?_c('div',{staticClass:"toast",class:_vm.type},[_vm._v("\n    "+_vm._s(_vm.message)+"\n  ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }